const keyCodes = {
	enter: 13,
	space: 32,
	left: 37,
	up: 38,
	right: 39,
	down: 40
};
export default keyCodes;
